import React, { StrictMode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { auth } from './pages/authpage';
import { User } from 'firebase/auth';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_fr from "./translations/fr/common.json";
import common_tr from "./translations/tr/common.json";
import common_en from "./translations/en/common.json";

i18next.init({
    interpolation: { escapeValue: false },
    lng: 'en',
    resources: {
        en: { common: common_en },
        fr: { common: common_fr },
        tr: { common: common_tr },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

function Root() {
    const [user, setUser] = useState<User | null>(null);
    const [authResolved, setAuthResolved] = useState(false);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
            setAuthResolved(true);
        });
        return () => unsubscribe();
    }, []);

    return (
        <StrictMode>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <I18nextProvider i18n={i18next}>
                    <App user={user} authResolved={authResolved} />
                </I18nextProvider>
            </BrowserRouter>
        </StrictMode>
    );
}

root.render(<Root />);
